import React from 'react';
import { CorporateTheme } from '../../../utils/themes';
import { RadioItem } from './RadioItem';
import { FieldLabel } from './FieldSettingsModal';
import { useTheme } from '../../../middleware/ThemeContext';
interface MandatoryFieldSettingsProps {
    isRequired: boolean;
    setIsRequired: (value: boolean) => void;
}

export const MandatoryFieldSettings: React.FC<MandatoryFieldSettingsProps> = ({
    isRequired,
    setIsRequired,
}) => {
    const { theme } = useTheme();
    return(
     <div className="px-3 py-2">
        <FieldLabel theme={theme}>
        Mandatory Field
    </FieldLabel>
        <div className="d-flex gap-4">
            <RadioItem theme={theme}>
                <input
                    type="radio"
                    name="mandatory"
                    checked={isRequired}
                    onChange={() => setIsRequired(true)} />
                <FieldLabel theme={theme}>
                    Yes
                </FieldLabel>
            </RadioItem>
            <RadioItem theme={theme}>
                <input
                    type="radio"
                    name="mandatory"
                    checked={!isRequired}
                    onChange={() => setIsRequired(false)} />
                <FieldLabel theme={theme}>
                    No
                </FieldLabel>
            </RadioItem>
        </div>
    </div>
);
};

export default MandatoryFieldSettings;

